import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

function DeleteAll() {
    const { t } = useTranslation('prepaidCard');
    const { push } = useFlow();
    const handleDeleteAll = () => {
        push('DeleteAllPrepaidCardsModal', {});
    };
    return (
        <Row justify='flex-end'
            className={styles.container}
            fullWidth >
            <Text color={colors.gray9}
                fontWeight='bold'
                size='lg'
                className={styles.delete}
                onClick={handleDeleteAll} >
                {t('manage.deleteAll')}
            </Text>
            <Tooltip right='unset' left={8} top={28}
                visibleKey='favoritePrepaidCard'
                backgroundColor={colors.gray6}
                align='left' >
                {t('manage.favoriteTooltip')}
            </Tooltip>
        </Row>
    );
}

export default DeleteAll;
